import { render, staticRenderFns } from "./bbgl-sx.vue?vue&type=template&id=6be63c2b&scoped=true"
import script from "./bbgl-sx.vue?vue&type=script&lang=js"
export * from "./bbgl-sx.vue?vue&type=script&lang=js"
import style0 from "./bbgl-sx.vue?vue&type=style&index=0&id=6be63c2b&prod&lang=scss"
import style1 from "./bbgl-sx.vue?vue&type=style&index=1&id=6be63c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be63c2b",
  null
  
)

export default component.exports